import {
  doc,
  getDoc,
  getFirestore,
  setDoc,
  updateDoc,
} from "firebase/firestore/lite";
import { TProfile } from "../models/users.model";

export function getUserProfile({
  onSuccess,
  onError,
}: {
  onSuccess?: (data: TProfile) => void;
  onError?: (data: any) => void;
}) {
  const db = getFirestore();

  getDoc(doc(db, "profile", localStorage.getItem("uid") || ""))
    .then((doc) => {
      if (doc.exists()) {
        const data = doc.data();
        if (data) {
          return onSuccess?.(data as TProfile);
        }
      }

      onError?.("User not found");
    })
    .catch((error) => {
      console.error("Error getting document:", error);
      onError?.(error);
    });
}

export function updateUserProfile({
  data,
  onSuccess,
  onError,
}: {
  data: {
    name: string;
    lastName: string;
    avatar?: string;
    birthday?: string;
    gender?: string;
    language: string;
    country?: string;
    interests?: string[];
    dateFormat?: string;
  };
  onSuccess?: (data: TProfile) => void;
  onError?: (data: any) => void;
}) {
  const db = getFirestore();

  const uid = localStorage.getItem("uid") || "";

  const docData = {
    ...data,
    updatedAt: new Date().toISOString(),
  };

  getDoc(doc(db, "profile", uid)).then((_doc) => {
    if (_doc.exists()) {
      updateDoc(doc(db, "profile", uid), docData)
        .then(() => {
          onSuccess?.(docData as TProfile);
        })
        .catch((error) => {
          console.error("Error updating document: ", error);
          onError?.(error);
        });
    } else {
      setDoc(doc(db, "profile", uid), docData)
        .then(() => {
          onSuccess?.(docData as TProfile);
        })
        .catch((error) => {
          console.error("Error updating document: ", error);
          onError?.(error);
        });
    }
  });
}
